import React from 'react';
import EntityConnect from '../components/connectParams/EntityConnect';
import { connect } from 'react-redux';
import {
  selectLinkedSourceById,
  getSelectedFlow,
  selectLinkedTargetById,
  selectLinkedConnectorById,
} from '../redux/selectors';

const ConnectParams = (props) => {
  return <EntityConnect {...props} />;
};

const mapStateToProps = (state, props) => {
  const entity = state.entities.selectedEntity;
  const entityId = entity.id ?? entity.tap ?? entity.target
  const helperText = typeof state.configuration.helperText === 'string' ? state.configuration.helperText : state.configuration.helperText?.[entityId]

  return {
    connectParams: state.configuration.connectParams,
    listener: state.configuration.listener,
    widgetTenant: state.configuration.tenant_id,
    helperText,
    multipleTenantLinks: state.preferences.multipleTenantLinks,
    entity,
    company: state.preferences.company,
    linkedSource: entity?.entityType === 'source' && selectLinkedSourceById(entity.tap),
    linkedTarget: entity?.entityType === 'target' && selectLinkedTargetById(entity.target),
    linkedConnector: entity?.entityType === 'connector' && selectLinkedConnectorById(entity.id),
    isConnected:
      (state.targets.selectedTarget?.target && state.targets.selectedTarget.target === entity.target) ||
      (state.sources.selectedSource && state.sources.selectedSource.tap === entity.tap) ||
      (state.connectors.selectedConnector && state.connectors.selectedConnector.id == entity.id),
    flowId: getSelectedFlow(),
    nextStep: state.configuration.nextStep,
  };
};

export default connect(mapStateToProps)(ConnectParams);
